import ilComponent from './Statement'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}
